export default "__VITE_ASSET__6474e981__"